const isTextTruncated = (
  text: string,
  textElementRef: React.RefObject<HTMLParagraphElement>
) => {
  if (!textElementRef.current || !text) return false;

  // Create a temporary element to measure the full text height
  const tempElement = document.createElement('div');
  const computedStyle = window.getComputedStyle(textElementRef.current);

  // Copy relevant styles to get accurate measurement
  tempElement.style.font = computedStyle.font;
  tempElement.style.fontSize = computedStyle.fontSize;
  tempElement.style.fontFamily = computedStyle.fontFamily;
  tempElement.style.fontWeight = computedStyle.fontWeight;
  tempElement.style.lineHeight = computedStyle.lineHeight;
  tempElement.style.letterSpacing = computedStyle.letterSpacing;
  tempElement.style.width = computedStyle.width;
  tempElement.style.position = 'absolute';
  tempElement.style.visibility = 'hidden';
  tempElement.style.height = 'auto';
  tempElement.style.whiteSpace = 'normal';
  tempElement.style.overflowWrap = 'break-word';
  tempElement.textContent = text;

  document.body.appendChild(tempElement);
  const fullTextHeight = tempElement.offsetHeight;
  document.body.removeChild(tempElement);

  // Compare with the current element's height
  const currentHeight = textElementRef.current.offsetHeight;

  return fullTextHeight > currentHeight;
};

export default isTextTruncated;
